module.exports = __webpack_public_path__ + "img/hero.5f197dac.webp";